<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Bank">
        <template slot="button">
          <button-add v-if="cP(28)" :to="{name: 'banks-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/banks" :fields="fields">
            <template v-slot:4="{item}">
              <b-badge variant="light-primary" v-if="item[4]==1">Utama</b-badge>
              <b-badge variant="light-warning" v-else>Bukan Utama</b-badge>
            </template>
            <template v-slot:5="data">
              <div class="float-none">
                <button-link v-if="cP(29)" size="sm" :to="{name:'banks-edit',params:{id: data.item[5]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(30)" @ondelete="deleteRow" :id="data.item[5]" :name="`${data.item[0]} (${data.item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'
import {BBadge} from 'bootstrap-vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
    BBadge
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Nama Bank'},
        1:{sortable: true, searchable: true, label:'No. Rekening'},
        2:{sortable: true, searchable: true, label:'Cabang'},
        3:{sortable: true, searchable: true, label:'Atas Nama'},
        4:{sortable: true, searchable: true, label:'Tipe Akun'},
        5:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('banks/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>